// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const FlyingEnvelopeIcon = createSvgIcon(
  <svg fill="currentColor" viewBox="0 0 32 25">
    <path
      fillRule="evenodd"
      d="m26.02 1.47 5.77 11.67c.26.52.28 1.12.07 1.66q-.3.76-1.02 1.14L13.11 24.7a2 2 0 0 1-1.35.16 2 2 0 0 1-1.45-1.11L4.54 12.07l-.14-.3a2.07 2.07 0 0 1 .95-2.8L23.08.23a2.1 2.1 0 0 1 2.8.95zM5.73 9.76a1.23 1.23 0 0 0-.54 1.62l.05.12 13.02 3.17a1.3 1.3 0 0 0 1.5-.73l5.38-12.28-.05-.11A1.2 1.2 0 0 0 23.47 1zM12.5 24q.11-.03.22-.09l17.73-8.75q.18-.1.33-.25l-7.74-2.22a.44.44 0 0 1-.3-.55c.06-.23.3-.36.54-.3l7.84 2.26q.01-.3-.12-.57L25.65 2.7l-5.1 11.6a2.2 2.2 0 0 1-2.5 1.23l-12.3-3 5.35 10.84q.17.34.5.51l3-7.64a.44.44 0 0 1 .81.32zM1.08 18.27a1 1 0 0 1-.2.04.4.4 0 0 1-.4-.24.44.44 0 0 1 .21-.59l3.73-1.84c.22-.1.49-.02.6.2.1.21 0 .48-.2.59zm2.9.67c.22-.1.48-.02.59.2s.01.48-.2.59L.64 21.57a1 1 0 0 1-.2.05.4.4 0 0 1-.4-.25.45.45 0 0 1 .21-.6zm2.9 1.65-3.74 1.84c-.21.11-.3.38-.2.6q.13.23.4.24.1 0 .2-.05l3.72-1.84c.22-.1.31-.37.2-.59a.44.44 0 0 0-.59-.2"
      clipRule="evenodd"
    />
  </svg>,
  "FlyingEnvelope",
);
export default FlyingEnvelopeIcon;
